import { mapActions, mapGetters, mapMutations } from 'vuex'

export const couponDiscount = {
  props: {},

  data: () => ({}),

  computed: {
    ...mapGetters(['benefit', 'benefitDistribution', 'generatedBenefitCode', 'benefitMovementHistory', 'metrics']),
  },

  methods: {
    ...mapMutations(['SET_BENEFIT', 'SET_BENEFIT_DISTRIBUTION', 'SET_BENEFIT_MOVEMENT_HISTORY', 'SET_GENERATED_BENEFIT_CODE', 'SET_METRICS']),
    ...mapActions([
      'getBenefitMetricsById',
      'getBenefitMovementHistory',
      'exportBenefitMovementHistoryReport',
      'getBenefitDistribution',
      'cloneBenefit',
      'getRevenue',
    ]),
  },
}
